var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVControlStopped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.87 12h-3.74c-.625 0-1.13.53-1.13 1.183v13.634c0 .653.505 1.183 1.13 1.183h3.74c.624 0 1.13-.53 1.13-1.183V13.183C18 12.53 17.494 12 16.87 12zM26.87 12h-3.74c-.624 0-1.13.53-1.13 1.183v13.634c0 .653.506 1.183 1.13 1.183h3.74c.624 0 1.13-.53 1.13-1.183V13.183C28 12.53 27.494 12 26.87 12z",
    fill: "#fff"
  })));
}

export default SvgVControlStopped;